import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class File extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get fileUrl() {
    return get(this, '_file.value[0].url', '');
  }

  get fileName() {
    return get(this, '_file.value[0].name', '');
  }

  get fileDescription() {
    return get(this, '_file.value[0].description', '');
  }

  get fileSize() {
    return get(this, '_file.value[0].size', '');
  }

  get fileType() {
    return get(this, '_file.value[0].type', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/File.model.js